module.exports = __webpack_public_path__ + "img/scene1.d46e2c70.jpg";